import { object, string } from "yup";

export const defaultValues = {
	booking: "",
	email: "",
};

export const validationSchema = object().shape({
	booking: string().required({ id: "error.booking.reference.required.error" }),
	email: string().required({ id: "error.booking.email.required.error" }),
});
